
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from './component/home/home';
import PrivacyPolicyScreen from './component/PrivacyPolicy';
import { AuthProvider } from './context/authContext';

function App() {
  return (
<AuthProvider>
      <Router>
      <Routes>
        <Route path='/' element={<Home />} /> 
        <Route path='/privacy' element={<PrivacyPolicyScreen />} /> 

        {/* <Route path='/login' element={<Login />} /> */}
        {/* <Route path='/recharge' element={<User />} /> */}


        {/* private Routes  */}
        <Route path ="/admin">
          {/* <Route path='recharge' element = {<User />} /> */}
        </Route>
      </Routes>
    </Router>
</AuthProvider>
  );
}

export default App;
